export const PermissionAdministrator = {
    PUT: "mgr-accounts-**-PUT",
    POST: "mgr-accounts-POST",
    DELETE: "mgr-accounts-**-DELETE",
    GET: "mgr-accounts-GET",
    // TODO: verificar se está retornando key de get por uuid nas authorites do user
    GET_UUID: "mgr-accounts-**-PUT"
};